module.exports = __webpack_public_path__ + "img/customize-cv.dabc9198.svg";